module.exports = {
	"_args": [
		[
			{
				"raw": "axios@^0.21.4",
				"scope": null,
				"escapedName": "axios",
				"name": "axios",
				"rawSpec": "^0.21.4",
				"spec": ">=0.21.4 <0.22.0",
				"type": "range"
			},
			"/home/kingdarkness/DEV/1express/1e-cms"
		]
	],
	"_from": "axios@>=0.21.4 <0.22.0",
	"_hasShrinkwrap": false,
	"_id": "axios@0.21.4",
	"_inCache": true,
	"_location": "/axios",
	"_nodeVersion": "12.21.0",
	"_npmOperationalInternal": {
		"tmp": "tmp/axios_0.21.4_1630942542911_0.9205474689335591",
		"host": "s3://npm-registry-packages"
	},
	"_npmUser": {
		"name": "jasonsaayman",
		"email": "jasonsaayman@gmail.com"
	},
	"_npmVersion": "7.20.3",
	"_phantomChildren": {},
	"_requested": {
		"raw": "axios@^0.21.4",
		"scope": null,
		"escapedName": "axios",
		"name": "axios",
		"rawSpec": "^0.21.4",
		"spec": ">=0.21.4 <0.22.0",
		"type": "range"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/axios/-/axios-0.21.4.tgz",
	"_shasum": "c67b90dc0568e5c1cf2b0b858c43ba28e2eda575",
	"_shrinkwrap": null,
	"_spec": "axios@^0.21.4",
	"_where": "/home/kingdarkness/DEV/1express/1e-cms",
	"author": {
		"name": "Matt Zabriskie"
	},
	"browser": {
		"./lib/adapters/http.js": "./lib/adapters/xhr.js"
	},
	"bugs": {
		"url": "https://github.com/axios/axios/issues"
	},
	"bundlesize": [
		{
			"path": "./dist/axios.min.js",
			"threshold": "5kB"
		}
	],
	"dependencies": {
		"follow-redirects": "^1.14.0"
	},
	"description": "Promise based HTTP client for the browser and node.js",
	"devDependencies": {
		"coveralls": "^3.0.0",
		"es6-promise": "^4.2.4",
		"grunt": "^1.3.0",
		"grunt-banner": "^0.6.0",
		"grunt-cli": "^1.2.0",
		"grunt-contrib-clean": "^1.1.0",
		"grunt-contrib-watch": "^1.0.0",
		"grunt-eslint": "^23.0.0",
		"grunt-karma": "^4.0.0",
		"grunt-mocha-test": "^0.13.3",
		"grunt-ts": "^6.0.0-beta.19",
		"grunt-webpack": "^4.0.2",
		"istanbul-instrumenter-loader": "^1.0.0",
		"jasmine-core": "^2.4.1",
		"karma": "^6.3.2",
		"karma-chrome-launcher": "^3.1.0",
		"karma-firefox-launcher": "^2.1.0",
		"karma-jasmine": "^1.1.1",
		"karma-jasmine-ajax": "^0.1.13",
		"karma-safari-launcher": "^1.0.0",
		"karma-sauce-launcher": "^4.3.6",
		"karma-sinon": "^1.0.5",
		"karma-sourcemap-loader": "^0.3.8",
		"karma-webpack": "^4.0.2",
		"load-grunt-tasks": "^3.5.2",
		"minimist": "^1.2.0",
		"mocha": "^8.2.1",
		"sinon": "^4.5.0",
		"terser-webpack-plugin": "^4.2.3",
		"typescript": "^4.0.5",
		"url-search-params": "^0.10.0",
		"webpack": "^4.44.2",
		"webpack-dev-server": "^3.11.0"
	},
	"directories": {},
	"dist": {
		"shasum": "c67b90dc0568e5c1cf2b0b858c43ba28e2eda575",
		"tarball": "https://registry.npmjs.org/axios/-/axios-0.21.4.tgz",
		"fileCount": 44,
		"integrity": "sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==",
		"signatures": [
			{
				"sig": "MEUCIGkkAJ1lvuGlmUhSCUk69Ot9u/hhH8bBd+7yA7cyaIIAAiEA2hD60EdaF6ud13eUjHo/zRR0MdZ8boETX3PqRwsrwZU=",
				"keyid": "SHA256:jl3bwswu80PjjokCgh0o2w5c2U4LhQAE57gj9cz1kzA"
			}
		],
		"unpackedSize": 375349,
		"npm-signature": "-----BEGIN PGP SIGNATURE-----\r\nVersion: OpenPGP.js v3.0.13\r\nComment: https://openpgpjs.org\r\n\r\nwsFcBAEBCAAQBQJhNjVPCRA9TVsSAnZWagAA0foP/3y+vPMPeoBU5dw1GOw+\npuX9t90nj+UaF116uDtZy1nmLl3CI+75T40P6OfbRq8AqTtIZ3GAb1hgFWDD\njftxo/P6kNlQrokmw5Nlpz3orM2Pobmk/TW56vd4CknIBw8PlBW+JQHZpPfY\nKjCg2rCv3XGqcFX8FGxE9sagkaMmomAZSNhw+86IsqWn4PYwL52prAVK1TNF\nBGoJgQCQ7Gh0XGa50SINUuVfnZ/SpYLGMFV+vlZGqVSOCS+Al/SshpldSA0A\nhCf7YUcLgqcej+l+EHFLFqO6iq78VayCTjqgSDM6USC8a17zfAaq/0bJdEht\nM1e3OhtcnUyDC00I5PPGv1PW3N1J8eptu6QyREsPoHRUqVGX0u1eHTB3Mbr2\n8VLwYal453QJ9FN7pW24U7ZCJy953gtJ99DY0KIXcl22+U1X0pNlzYhoghUh\nBpajCP2kDps7SmcRQ0oGCefebuTT+czP7lAzHtF5tAg0FFtMt6X5I8bQahL4\n/22ITU9SdY1+SZRj+oWrj7CJAfjODRd9VmAMbwxgTnStzeWLvU/Cwc1l6euZ\nPh2TnA3smLJ4McjaP9Mj7PAXxGVhmwoMLnAcqpu01L7Dy2C8SdZ+lgy/+1Mz\ncYW4OibWQjCM8/eGmFGS82R2Tg20Mx+aZ09YQo1mjYxZ3SvTmlVh1Ee7Xvc2\nPkX7\r\n=rPmy\r\n-----END PGP SIGNATURE-----\r\n"
	},
	"gitHead": "84f009d862e06ef7339f0d45da061a15749ddfee",
	"homepage": "https://axios-http.com",
	"jsdelivr": "dist/axios.min.js",
	"keywords": [
		"xhr",
		"http",
		"ajax",
		"promise",
		"node"
	],
	"license": "MIT",
	"main": "index.js",
	"maintainers": [
		{
			"name": "mzabriskie",
			"email": "mzabriskie@gmail.com"
		},
		{
			"name": "nickuraltsev",
			"email": "nick.uraltsev@gmail.com"
		},
		{
			"name": "emilyemorehouse",
			"email": "emilyemorehouse@gmail.com"
		},
		{
			"name": "jasonsaayman",
			"email": "jasonsaayman@gmail.com"
		}
	],
	"name": "axios",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"url": "git+https://github.com/axios/axios.git",
		"type": "git"
	},
	"scripts": {
		"build": "NODE_ENV=production grunt build",
		"coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
		"examples": "node ./examples/server.js",
		"fix": "eslint --fix lib/**/*.js",
		"postversion": "git push && git push --tags",
		"preversion": "npm test",
		"start": "node ./sandbox/server.js",
		"test": "grunt test",
		"version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"
	},
	"typings": "./index.d.ts",
	"unpkg": "dist/axios.min.js",
	"version": "0.21.4"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/package.json
// module id = 335
// module chunks = 1